import UserEvent from './userEvent';
import CustomerEvent from './customerEvent';
import DashboardEvent from './dashboardEvent';
import NotificationEvent from './notificationEvent';
import WorkingTimeEvent from './workingTimeEvent';

const Event = {
    User: UserEvent,
    Customer: CustomerEvent,
    Dashboard: DashboardEvent,
    WorkingTime: WorkingTimeEvent,
    Notification: NotificationEvent,
};

export default Event;
